import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

const useWindowScrollPosition = ({
  isScrollTrackingDisabled = false,
  time,
  previousScrollPosition,
}) => {
  const [scrollPosition, setScrollPosition] = useState(
    previousScrollPosition ?? 0
  );

  useEffect(() => {
    const updatePosition = throttle(
      () => {
        if (window) {
          setScrollPosition(prevState =>
            prevState === window.scrollY ? prevState : window.scrollY
          );
        }
      },
      time,
      { leading: false }
    );

    if (!isScrollTrackingDisabled) {
      window.addEventListener('scroll', updatePosition, {
        capture: false,
        passive: true,
      });
    }

    return () => {
      window.removeEventListener('scroll', updatePosition);
    };
  }, [isScrollTrackingDisabled, time]);

  return scrollPosition;
};

export default useWindowScrollPosition;
